module.exports = __webpack_public_path__ + "img/group1Img.2e9121f1.png";